export class ResetPassword {
  public UserID: string;
  public Email: string;

}



// WEBPACK FOOTER //
// ./src/app/models/ResetPassword.ts